export const SERVICE_CODE = 'CONTRACTOR' + 'INVOICES' + '_SERVICE';
